<p-dialog [(visible)]="displayEmailReplyPopup" [modal]="true" [style]="{width: '55vw'}" class="layer2"
    (onHide)="closeEmailReplyPopup()">
    <div class="header p-d-flex p-jc-between">
        <h5>Email Reply</h5>
    </div>
    <p-card class="activity-card">
        <div class="p-d-flex">
            <div class="activity-icon bg-log p-shadow-3">
                <span class="pi pi-envelope"></span>
            </div>
            <div class="activity-content">
                <ng-container>
                    <div style="word-break: break-all;" class="p-mb-0" *ngIf="emailReplyData">
                        <div>
                            <h6 class="p-mb-1" style="display: inline-block;" *ngIf="emailReplyData?.isExternal">
                                <p>{{emailReplyData?.externalUserName}}<span
                                        *ngIf="emailReplyData?.externalUserName == null">{{emailReplyData?.externalUserEmail}}</span>
                                    (external)</p>
                            </h6>
                            <h6 class="p-mb-1" style="display: inline-block;" *ngIf="!emailReplyData?.isExternal">
                                {{ emailReplyData.createdByName }}
                            </h6>
                            <span class="p-ml-4" style="opacity: 0.8;">
                                {{emailReplyData?.date | localDate}}
                            </span>
                            <div>
                                <p style="word-break: break-all; white-space: pre-line;">
                                    {{emailReplyData?.comment}}
                                </p>
                            </div>
                            <ng-container *ngIf="emailReplyData.attachments && (emailReplyData.attachments.length > 0)">
                                <div class="attachments-container">
                                    <div class="p-chips">
                                        <ul class="p-chips-multiple-container">
                                            <ng-container
                                                *ngFor="let attachment of emailReplyData.attachments; let i = index">
                                                <li class="p-chips-token">

                                                    <span class="p-chips-token-label cursor-pointer" (click)="openFilePreview(attachment)">
                                                        {{ attachment?.name}}.{{attachment?.extension}}
                                                    </span>
                                                </li>
                                            </ng-container>
                                        </ul>
                                    </div>
                                </div>
                            </ng-container>

                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </p-card>


    <ng-template pTemplate="footer">
        <ng-container>
            <button pButton (click)="closeEmailReplyPopup()" label="Close" class="p-button-secondary"></button>

        </ng-container>
        <!-- <ng-container>
            <button pButton (click)="cancelLog();" label="Cancel" class="p-button-secondary"></button>
        </ng-container> -->
    </ng-template>
</p-dialog>

<!-- File Opener Modal -->
<app-shared-file-opener
    *ngIf="displayFilePreview"
    [modalDisplay]="displayFilePreview"
    [modalFile]="currentFile"
    (closeFilePreview)="closeFilePreview()">
</app-shared-file-opener>
